import { render } from "./contactus-footer.vue?vue&type=template&id=00f2fa5a&scoped=true"
import script from "./contactus-footer.vue?vue&type=script&lang=js"
export * from "./contactus-footer.vue?vue&type=script&lang=js"

import "./contactus-footer.vue?vue&type=style&index=0&id=00f2fa5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-00f2fa5a"

export default script